import { ProfileState } from './types'

export const state: ProfileState = {
  openDoctorDrawer: false
}
